<template>
    <div>
        <div class="columns m-t-20">
            <div class="column is-flex">
                <h2 class="has-text-weight-medium is-size-4">Inventario </h2>
                <b-switch  v-on:input="dispatchChange" v-model="inventory.trackStock" class="m-l-20" type="is-success">Control stock</b-switch>
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <b-field label="Cantidad total en stock">
                    <b-numberinput 
                    min="0"
                    type="is-light"
                    v-model="inventory.quantity"
                    v-on:input="dispatchChange"
                    controls-rounded
                    :disabled="!inventory.trackStock">
                    </b-numberinput>
                </b-field>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name:"InventoryForm",
    data(){
        return{
            inventory:{
                trackStock:false,
                code:"",
                quantity:0
            }
        }
    },
    methods:{
        dispatchChange(){
            this.$store.dispatch('updateData', {obj:'inventory', data:this.inventory})
        }
    },

}
</script>
